/* ========== CHART PARSER CONSTANTS ==========
 * Namespace URIs, anchor names, and the mappings that translate OOXML
 * chart-type element names into the internal `chartType` strings the
 * renderer's switch statement uses.
 * ============================================ */

export const CHART_URI    = "http://schemas.openxmlformats.org/drawingml/2006/chart";
export const CHART_EX_URI = "http://schemas.microsoft.com/office/drawing/2014/chartex";

// Drawing anchor element names — every embedded chart/image is wrapped in
// exactly one of these. Order matters: we check them in this order.
export const ANCHOR_NAMES = ["twoCellAnchor", "oneCellAnchor", "absoluteAnchor"];

// Standard (drawingml/2006/chart) chart-type element names. The parser
// loops over these and asks the plotArea whether each element is present.
export const STD_CHART_TYPES = [
  "barChart", "bar3DChart", "lineChart", "line3DChart",
  "pieChart", "pie3DChart", "doughnutChart", "areaChart", "area3DChart",
  "scatterChart", "radarChart", "bubbleChart", "stockChart", "surfaceChart",
  "surface3DChart", "ofPieChart",
];

// Extended chart format (chartEx) → renderer subtype. These are the modern
// Excel charts (Treemap, Sunburst, Funnel, Waterfall, etc.) that use a
// separate XML schema.
export const CHART_EX_LAYOUT_MAP = {
  treemap:         "treemap",
  sunburst:        "sunburst",
  funnel:          "funnel",
  waterfall:       "waterfall",
  boxWhisker:      "boxWhisker",
  regionMap:       "filledMap",
  clusteredColumn: "col",
  paretoLine:      "pareto",
  histogram:       "histogram",
};

// Standard chart element name → renderer chartType. Note these are the
// generic categories; bar vs col is decided by <c:barDir>, and ofPie is
// further split into pieOfPie vs barOfPie by <c:ofPieType>.
export const RENDER_TYPE_MAP = {
  barChart: "bar",      bar3DChart: "bar",
  lineChart: "line",    line3DChart: "line",
  pieChart: "pie",      pie3DChart: "pie",
  doughnutChart: "doughnut",
  areaChart: "area",    area3DChart: "area",
  scatterChart: "scatter",
  radarChart: "radar",
  bubbleChart: "bubble",
  stockChart: "stock",
  surfaceChart: "surface", surface3DChart: "surface",
  ofPieChart: "ofPie",
};

// Which OOXML element names trigger the renderer's 3-D code path.
export const IS_3D_TYPES = {
  bar3DChart: true,
  line3DChart: true,
  pie3DChart: true,
  area3DChart: true,
  surface3DChart: true,
};

// Theme color index map for schemeClr resolution. Indices 0-9 line up
// with how excelJSParser.js builds the themeColors array.
export const THEME_COLOR_MAP = {
  lt1: 0, dk1: 1, lt2: 2, dk2: 3,
  accent1: 4, accent2: 5, accent3: 6, accent4: 7, accent5: 8, accent6: 9,
  hlink: 10, folHlink: 11,
  // Aliases — bg1/tx1/bg2/tx2 are synonyms for lt1/dk1/lt2/dk2.
  bg1: 0, tx1: 1, bg2: 2, tx2: 3,
};
